import React from "react";
import { Button, Tag, Tooltip, Popconfirm } from "antd";
import {
  PlusOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import {
  getBankColumn,
  getAccountNumberColumn,
  getCurrencyColumn,
  getBalanceUpdatedColumn,
  getWalletUpdatedColumn,
  getTotalBalanceColumn,
  getWalletBalanceColumn,
} from "../accounts/accountColumnHelpers";

function ActionButtons({ record, onManual, onTransfer, onToggleActive, canOpenManualModal = false }) {
  const isActive = Boolean(record?.is_active);

  const stopPropagation = (event) => {
    event?.stopPropagation?.();
  };

  const handleManual = (event) => {
    stopPropagation(event);
    onManual?.(record);
  };

  const handleTransfer = (event) => {
    stopPropagation(event);
    onTransfer?.(record);
  };

  const handleToggle = (event) => {
    stopPropagation(event);
    onToggleActive?.(record, !isActive);
  };

  return (
    <div
      className="flex items-center justify-center gap-2"
      onClick={stopPropagation}
    > {canOpenManualModal && (
        <Tooltip title="Гараар орлогын гүйлгээ шивэх">
          <Button
            size="middle"
            className="flex h-9 items-center rounded-xl border-slate-200 px-3 font-medium shadow-sm hover:border-slate-300 hover:bg-slate-50"
            icon={<PlusOutlined />}
            onClick={handleManual}
            disabled={!isActive}
          >
            Гараар
          </Button>
        </Tooltip>
      )}

      <Tooltip title="Данс хооронд шилжүүлэг хийх">
        <Button
          size="middle"
          className="flex h-9 items-center rounded-xl px-3 font-medium shadow-sm"
          icon={<SwapOutlined />}
          onClick={handleTransfer}
          disabled={!isActive}
        >
          Шилжүүлэг
        </Button>
      </Tooltip>

      <Popconfirm
        title={isActive ? "Энэ дансыг идэвхгүй болгох уу?" : "Энэ дансыг идэвхжүүлэх үү?"}
        onConfirm={handleToggle}
        onCancel={stopPropagation}
        okText="Тийм"
        cancelText="Үгүй"
      >
      <Button
        type="default"
        size="middle"
        className={`flex h-9 items-center rounded-xl px-3 font-medium shadow-none ${
          isActive
            ? "border-neutral-300 text-neutral-800 bg-neutral-100"
            : "border-neutral-300 text-neutral-700 bg-white hover:bg-neutral-100"
        }`}
        onClick={stopPropagation}
      >
        {isActive ? "Идэвхгүй болгох" : "Идэвхжүүлэх"}
      </Button>
      </Popconfirm>
    </div>
  );
}

export function createInstitutionWalletColumns({
  onManual,
  onTransfer,
  onToggleActive,
  canOpenManualModal = false,
}) {
  return [
    {
      title: "Үйлдлүүд",
      key: "actions",
      width:canOpenManualModal ? 400 : 300,
      align: "center",
      fixed: "left",
      render: (_, record) => (
        <ActionButtons
          record={record}
          onManual={onManual}
          onTransfer={onTransfer}
          onToggleActive={onToggleActive}
          canOpenManualModal={canOpenManualModal}
        />
      ),
    },
    getBankColumn(),
    getAccountNumberColumn(),
    getCurrencyColumn(),
    {
      title: "Төлөв",
      dataIndex: "is_active",
      key: "is_active",
      width: 120,
      align: "center",
      render: (value) => (
        <Tag color={value ? "green" : "red"}>
          {value ? "ИДЭВХТЭЙ" : "ИДЭВХГҮЙ"}
        </Tag>
      ),
    },
    {
      ...getTotalBalanceColumn(),
      align: "right",
    },
    {
      ...getWalletBalanceColumn(),
      align: "right",
    },
    getBalanceUpdatedColumn(),
    getWalletUpdatedColumn(),
  ];
}